import React from 'react';
import IphoneFrame from '../assets/images/iPhone X .png';
import Mask from '../assets/images/Mask.png';
import Mask2 from '../assets/images/Mask2.png';
import Mask3 from '../assets/images/Mask3.png';
import ImageContainer from './ImageContainer';
import GooglePlay from '../assets/images/GooglePlay.png';
import AppStore from '../assets/images/AppStore.png';
import Highlight from './Highlight';

const MobileApp = () => (
  <div style={styles.section}>
    <div style={styles.imageBox}>
      <ImageContainer frameImage={IphoneFrame} screenImage={Mask} />
      <ImageContainer frameImage={IphoneFrame} screenImage={Mask2} />
      <ImageContainer frameImage={IphoneFrame} screenImage={Mask3} />
    </div>

    <div style={styles.textWrapper}>
      <Highlight width={619} height={332} />
      <div style={styles.textBox}>
        <h2 style={styles.heading}>Mobilna aplikacija</h2>
        <p style={styles.subtext}>
        Ovde ide tekst o mobilnoj aplikaciji i funkcionalnostima • Ovde ide tekst o mobilnoj aplikaciji i funkcionalnostima • Ovde ide tekst o mobilnoj aplikaciji i funkcionalnostima • Ovde ide tekst o mobilnoj aplikaciji i funkcionalnostima • Ovde ide tekst o mobilnoj aplikaciji i funkcionalnostima
        </p>
        <div style={styles.storeButtons}>
          <img src={GooglePlay} alt="Google Play" style={styles.storeImage} />
          <img src={AppStore} alt="App Store" style={styles.storeImage} />
        </div>
      </div>
    </div>
  </div>
);

export default MobileApp;


const styles = {
  section: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(23, 23, 24)',
    padding: 40,
    gap: 40,
    flexWrap: 'wrap',
    marginBottom: '100px'

  },
  imageBox: {
    display: 'flex',
    gap: '40px',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '100%', 
  },
  
  textWrapper: {
    position: 'relative',
    width: 619,
    height: 344,
    zIndex: 0,
  },
  textBox: {
    position: 'relative',
    backgroundImage: 'linear-gradient(232deg, rgba(153, 153, 153, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%)',
    padding: 20,
    borderRadius: 12,
    width: 619,
    height: 332,
    zIndex: 2,
    backdropFilter: 'blur(6px)',
  },
  heading: {
    fontSize: '48px',
  fontWeight: 700,
  backgroundImage: 'linear-gradient(235.42deg, #EEFF00 0%, #B6BB6C 100%)',
  backgroundClip: 'text',
  color: 'transparent',
  marginBottom: 16,
  lineHeight: '64px',
  },
  subtext: {
    fontSize: '18px',
    color: '#ffffff',
    lineHeight: '28px',
    marginBottom: 24,
  },
  storeButtons: {
    display: 'flex',
    gap: 20,
  },
  storeImage: {
    width: 215,
    height:64,
    cursor: 'pointer',

  },
};
